import { render } from "./multiColumn.vue?vue&type=template&id=2ad46673"
import script from "./multiColumn.vue?vue&type=script&lang=js"
export * from "./multiColumn.vue?vue&type=script&lang=js"

import "./multiColumn.vue?vue&type=style&index=0&id=2ad46673&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__